import React from 'react';
import { Grid, Typography } from '@mui/material';
import { BreathingSparkAnimation } from 'components/Animations';
import { useNavigate } from 'react-router-dom';
import { SparkButton } from 'sharedComponents/UI';

function SparkRunDraftMessage() {
  const navigate = useNavigate();
  return (
    <Grid
      container
      width='100%'
      height='100%'
      justifyContent='center'
      alignItems='center'
      flexDirection='column'
      gap={1.5}
    >
      <BreathingSparkAnimation height={100} width={100} />
      <Typography variant='h4' fontWeight='bold'>
        Maintenance in Progress
      </Typography>
      <Typography variant='body1' fontWeight='bold' color='GrayText'>
        The Spark creator is currently working on updates
      </Typography>

      <SparkButton
        variant='contained'
        sx={{ py: 2 }}
        onClick={() => navigate('/dashboard')}
      >
        Go to Dashboard
      </SparkButton>
    </Grid>
  );
}

export default SparkRunDraftMessage;
